import { ActivityLogStatusNumber } from "../constant/activity-log-constants";

export class StatusLookup {
  Id?: number;
  RecordId?: number;
  Number: ActivityLogStatusNumber;
  Name: string;
  EntityTypeId: number;
  IsDeleted: boolean;

  constructor(obj?: Partial<StatusLookup>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
